import React from 'react';
import images from '../constants/images';

const Logo = ({ className = "h-12", showText = true }) => {
  return (
    <div className={`flex items-center gap-3 ${className}`}>
      <img 
        src={images.logo} 
        alt="fit29" 
        className="h-full w-auto object-contain"
        onError={(e) => {
          // If image fails, we could show a text-based logo or fallback
          console.warn("Logo image failed to load");
        }}
      />
      {showText && (
        <span className="font-Gibson font-bold text-2xl tracking-tight flex items-center" style={{ color: 'var(--clr-main)' }}>
          fit29
        </span>
      )}
    </div>
  );
};

export default Logo;
